// extracted by mini-css-extract-plugin
export default {"taskChipWrapper":"document-tab_taskChipWrapper__mrmNy"};